import jQuery from 'jquery';

window.$ = jQuery; // workaround for https://github.com/parcel-bundler/parcel/issues/333

import 'bootstrap';

import instantsearch from 'instantsearch.js/es';

import {
    searchBox,
    infiniteHits,
    configure,
    stats,
    refinementList,
    currentRefinements,
} from 'instantsearch.js/es/widgets';
import TypesenseInstantSearchAdapter from 'typesense-instantsearch-adapter';
import { SearchClient as TypesenseSearchClient } from 'typesense';
import STOP_WORDS from './utils/stop_words.json';

let TYPESENSE_SERVER_CONFIG = {
    apiKey: "trist",
    nodes: [
        {
            host: "typesense-trist.up.railway.app",
            port: "443",
            protocol: "https",
        },
    ],
    numRetries: 8,
};

const INDEX_NAME = "blog"

async function getIndexSize() {
    let typesenseSearchClient = new TypesenseSearchClient(
        TYPESENSE_SERVER_CONFIG
    );
    let results = await typesenseSearchClient
        .collections(INDEX_NAME)
        .documents()
        .search({ q: '*' });

    return results['found'];
}

let indexSize;

(async () => {
    indexSize = await getIndexSize();
})();

// refine the query you entered
function queryWithoutStopWords(query) {
    const words = query.replace(/[&\/\\#,+()$~%.'":*?<>{}]/g, '').split(' ');
    return words
        .map(word => {
            if (STOP_WORDS.includes(word.toLowerCase())) {
                return null;
            } else {
                return word;
            }
        })
        .filter(w => w)
        .join(' ')
        .trim();
}

const typesenseInstantsearchAdapter = new TypesenseInstantSearchAdapter({
    server: TYPESENSE_SERVER_CONFIG,
    // The following parameters are directly passed to Typesense's search API endpoint.
    // So you can pass any parameters supported by the search endpoint below.
    // queryBy is required.
    additionalSearchParameters: {
        queryBy: 'hierarchy.lvl0,hierarchy.lvl1,hierarchy.lvl2,hierarchy.lvl3,hierarchy.lvl4,hierarchy.lvl5,content',
        query_by_weights: '2,2,2,2,2,2,1',
    },
});
const searchClient = typesenseInstantsearchAdapter.searchClient;

const search = instantsearch({
    searchClient,
    indexName: INDEX_NAME,
    routing: true,
    // don't display search results when no queries
    searchFunction(helper) {
        if (helper.state.query === '') {
            $('#results-section').addClass('d-none');
        } else {
            $('#results-section').removeClass('d-none');
            helper.search();
        }
    },
});

search.addWidgets([
    searchBox({
        container: '#searchbox',
        showSubmit: false,
        showReset: false,
        placeholder: 'Type to search',
        autofocus: true,
        cssClasses: {
            input: 'form-control',
        },
        // preprocess the query
        queryHook(query, search) {
            const modifiedQuery = queryWithoutStopWords(query);
            if (modifiedQuery.trim() !== '') {
                search(modifiedQuery);
            }
        },
    }),

    stats({
        container: '#stats',
        templates: {
            text: ({ nbHits, hasNoResults, hasOneResult, processingTimeMS }) => {
                let statsText = '';
                if (hasNoResults) {
                    statsText = 'No results';
                } else if (hasOneResult) {
                    statsText = '1 result';
                } else {
                    statsText = `✨ ${nbHits.toLocaleString()} results`;
                }
                return `${statsText} found ${indexSize ? ` - Searched ${indexSize.toLocaleString()} records` : ''
                    } in ${processingTimeMS}ms.`;
            },
        },
    }),

    infiniteHits({
        container: '#hits',
        transformItems: items => {
            return items.filter(item => {
                // filter out all items in which search hit in header, but not hit the content
                if ("content" in item._highlightResult && item._highlightResult.content.matchLevel == "none")
                    return false;
                return true;
            }).map(item => {
                let fixedLink = item.url
                if (!item.url.startsWith('http')) {
                    fixedLink = `http://${item.url}`
                }

                // enable highlight for title and headings
                if (item._highlightResult) {
                    for (const property in item._highlightResult) {
                        if (property.includes(".")) {
                            let res = property.split(".")
                            item._highlightResult[res[0]][res[1]] = item._highlightResult[property]
                        }
                    }
                }

                return {
                    ...item,
                    link: fixedLink,
                };
            });
        },
        cssClasses: {
            list: 'list-unstyled grid-container',
            item: 'd-flex flex-column search-result-card bg-light-2 p-3',
            loadMore: 'btn btn-primary mx-auto d-block mt-4',
        },
        templates: {
            item: `
            <h6 class="text-primary fw-light font-letter-spacing-loose mb-0">
                <a href="{{ link }}" target="_blank">
                    {{ hierarchy.lvl0 }}
                </a>
            </h6>

            <div class="text-muted">
              from
			  {{ main_category_tag }}
            </div>

            <div class="mt-2 mb-3">
              <ol class="mt-2 mb-2">
    		    {{#hierarchy.lvl1}}<li>{{#helpers.highlight}}{ "attribute": "hierarchy.lvl1", "highlightedTagName": "mark" }{{/helpers.highlight}}</li>{{/hierarchy.lvl1}}
    		    {{#hierarchy.lvl2}}<li>{{#helpers.highlight}}{ "attribute": "hierarchy.lvl2", "highlightedTagName": "mark" }{{/helpers.highlight}}</li>{{/hierarchy.lvl2}}
    		    {{#hierarchy.lvl3}}<li>{{#helpers.highlight}}{ "attribute": "hierarchy.lvl3", "highlightedTagName": "mark" }{{/helpers.highlight}}</li>{{/hierarchy.lvl3}}
    		    {{#hierarchy.lvl4}}<li>{{#helpers.highlight}}{ "attribute": "hierarchy.lvl4", "highlightedTagName": "mark" }{{/helpers.highlight}}</li>{{/hierarchy.lvl4}}
    		    {{#hierarchy.lvl5}}<li>{{#helpers.highlight}}{ "attribute": "hierarchy.lvl5", "highlightedTagName": "mark" }{{/helpers.highlight}}</li>{{/hierarchy.lvl5}}
              </ol>
    		  {{#content}}
				{{#helpers.highlight}}{ "attribute": "content", "highlightedTagName": "mark" }{{/helpers.highlight}}
              {{/content}}
            </div>

            <div class="mt-auto">
              <div class="text-end">
                <a href="#" aria-roledescription="button" class="readDirectionsButton" data-bs-toggle="modal" data-bs-target="#readDirectionsModalLabel{{ __hitIndex }}">
                  <span>Read Details</span>
                </a> 🚀
              </div>

              <div class="modal fade" tabindex="-1" aria-labelledby="readDirectionsModalLabel-1" aria-hidden="true" id="readDirectionsModalLabel{{__hitIndex}}">
                <div class="modal-dialog modal-lg modal-dialog-scrollable">
                  <div class="modal-content">
                    <div class="modal-header">
                      <h5 class="modal-title text-primary">
                        {{ hierarchy.lvl0 }}
                        <br>
                        <small class="font-size-sm">
                          <a href="{{ link }}" target="_blank" class="fw-light">Read on {{ hierarchy.lvl0 }} »</a>
                        </small>
                      </h5>
                      <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close">
                      </button>
                    </div>
                    <div class="modal-body">
                      <h5 class="mb-1">Content</h5>
            		  {{^content}}
                        <div class="alert alert-warning small mt-2" role="alert">
                          Note: Your search hits on one level of hierachy, please check the content below for details. 
                        </div>
            		  {{/content}}
                      <p>
                		{{#content}}
            			  {{#helpers.highlight}}{ "attribute": "content", "highlightedTagName": "mark" }{{/helpers.highlight}}
                        {{/content}}
                      </p>
                      <h5 class="mb-1">Hierarchies</h5>
                      <ol class="mt-2">
            		    {{#hierarchy.lvl1}}<li>{{#helpers.highlight}}{ "attribute": "hierarchy.lvl1", "highlightedTagName": "mark" }{{/helpers.highlight}}</li>{{/hierarchy.lvl1}}
            		    {{#hierarchy.lvl2}}<li>{{#helpers.highlight}}{ "attribute": "hierarchy.lvl2", "highlightedTagName": "mark" }{{/helpers.highlight}}</li>{{/hierarchy.lvl2}}
            		    {{#hierarchy.lvl3}}<li>{{#helpers.highlight}}{ "attribute": "hierarchy.lvl3", "highlightedTagName": "mark" }{{/helpers.highlight}}</li>{{/hierarchy.lvl3}}
            		    {{#hierarchy.lvl4}}<li>{{#helpers.highlight}}{ "attribute": "hierarchy.lvl4", "highlightedTagName": "mark" }{{/helpers.highlight}}</li>{{/hierarchy.lvl4}}
            		    {{#hierarchy.lvl5}}<li>{{#helpers.highlight}}{ "attribute": "hierarchy.lvl5", "highlightedTagName": "mark" }{{/helpers.highlight}}</li>{{/hierarchy.lvl5}}
                      </ol>
                      <div class="alert alert-warning small mt-2" role="alert">
                        Note: Above is the hierarchy of the search result, each ordered list item corresponds to a heading level. The first item corresponds to the title of the post. 
                      </div>
                    </div>
                    <div class="modal-footer">
                      <button type="button" class="btn btn-primary" data-bs-dismiss="modal">Close</button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
        `,
            empty: 'No records found for <q>{{ query }}</q>. Try another search term.',
        },
    }),

    refinementList({
        container: '#category-refinement-list',
        attribute: 'main_category_tag',
        searchable: true,
        searchablePlaceholder: 'Search categories',
        showMore: true,
        limit: 50,
        showMoreLimit: 100,
        operator: 'or',
        cssClasses: {
            searchableInput: 'form-control form-control-sm mb-2 border-light-2',
            searchableSubmit: 'd-none',
            searchableReset: 'd-none',
            showMore: 'btn btn-secondary btn-sm align-content-center',
            list: 'list-unstyled',
            count: 'badge rounded-pill text-dark bg-light-2 ms-2',
            label: 'd-flex align-items-center text-capitalize',
            checkbox: 'me-2',
        }
    }),

    configure({
        hitsPerPage: 15,
    }),

    currentRefinements({
        container: '#current-refinements',
        cssClasses: {
            list: 'list-unstyled',
            label: 'd-none',
            item: 'h5',
            category: 'badge rounded-pill bg-light-2 text-dark px-2 m-1',
            delete: 'btn btn-sm btn-link p-0 ps-2',
        },
        transformItems: items => {
            const modifiedItems = items.map(item => {
                return {
                    ...item,
                    label: '',
                };
            });
            return modifiedItems;
        },
    }),
]);

// change when clicking the Try search term
function handleSearchTermClick(event) {
    search.helper.clearRefinements();
    search.helper.setQuery(event.currentTarget.textContent).search();
}

search.start();

$(() => {
    const $searchBox = $('#searchbox input[type=search]');

    // Handle example search terms in Try:
    $('.clickable-search-term').on('click', handleSearchTermClick);

    // when searching ,auto scroll to top
    if (!matchMedia('(min-width: 768px)').matches) {
        $searchBox.on('focus, keydown', () => {
            $('html, body').animate(
                {
                    scrollTop: $('#searchbox-container').offset().top,
                },
                100
            );
        });
    }
});
